/* unplugin-vue-components disabled */import { render } from "./MyDepartment.vue?vue&type=template&id=1095b7c4&scoped=true&ts=true"
import script from "./MyDepartment.vue?vue&type=script&lang=ts"
export * from "./MyDepartment.vue?vue&type=script&lang=ts"

import "./MyDepartment.vue?vue&type=style&index=0&id=1095b7c4&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1095b7c4"]])

export default __exports__